import { hdmgdjDownloadHighlights } from "@/mocks/hdmgdj/download";

export default function HdmgdjDownloadHighlights() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="hdmgdj-container">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {hdmgdjDownloadHighlights.map((item, index) => (
            <div
              key={item.id}
              className="hdmgdj-reveal flex items-start gap-4 bg-background-50 border border-background-200 rounded-lg p-5"
              style={{ transitionDelay: `${index * 60}ms` }}
            >
              <span
                className={`w-11 h-11 flex items-center justify-center rounded-lg text-xl shrink-0 ${
                  index % 2 === 0 ? "bg-primary-100 text-primary-700" : "bg-accent-100 text-accent-700"
                }`}
              >
                <i className={item.icon} />
              </span>
              <div>
                <h3 className="text-[16px] font-bold font-label text-foreground-950">{item.title}</h3>
                <p className="mt-1 text-[13px] leading-6 text-foreground-600">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}